import { Box, useTheme } from "@mui/material";
import { useState } from "react";

import { Command } from "~/components/guides/components/command";
import { useToken } from "~/providers/token";
import { InstallationMethodSelector } from "./components/InstallationMethodSelector";
import { PowerShellInstallationSteps } from "./components/PowerShellInstallationSteps";
import { MsiInstallationSteps } from "./components/MsiInstallationSteps";
import { InstallationMethod } from "./types";
import { IntegrationAddHeader } from "../../headers/IntegrationAddHeader";
import { OtherIntegrations } from "../../headers/types";

export const WindowsIntegrationSetupPage = () => {
  const theme = useTheme();
  const { token } = useToken();
  const tokenValue = token?.value ?? "";
  const [selectedMethod, setSelectedMethod] = useState<InstallationMethod>(
    InstallationMethod.PowerShell,
  );

  return (
    <Box>
      <IntegrationAddHeader type={OtherIntegrations.WINDOWS} />

      <Box>
        <Box sx={{ mb: 2 }}>
          <Command
            number={1}
            options={{
              fontSize: { xs: 16 },
              dotColor: theme.palette.background.lightest,
            }}
          >
            Select your installation method
          </Command>
        </Box>
        <InstallationMethodSelector
          selectedMethod={selectedMethod}
          onMethodChange={setSelectedMethod}
        />

        {selectedMethod === "powershell" && (
          <PowerShellInstallationSteps tokenValue={tokenValue} />
        )}

        {selectedMethod === "msi" && (
          <MsiInstallationSteps tokenValue={tokenValue} />
        )}
      </Box>
    </Box>
  );
};
